import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import SignInButton from './SignInButton';
import Profile from './Profile';
import Questions from './Questions';
import AdminQuestions from './AdminQuestions';
import Matches from './Matches';
import MatchDetail from './MatchDetail';
import Beacons from './Beacons';
import { auth } from './firebase';
import { onAuthStateChanged, User } from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

function App(): React.ReactElement {
  const [user, setUser] = useState<User | null>(null);

  // Create user document in Firestore if it doesn't exist
  const createUserDocument = async (user: User): Promise<void> => {
    if (!user) return;

    const userDocRef = doc(db, "users", user.uid);
    const userDoc = await getDoc(userDocRef);

    // Only create the document if it doesn't exist
    if (!userDoc.exists()) {
      await setDoc(userDocRef, {
        uid: user.uid,
        name: user.displayName || '',
        dateOfBirth: '',
        description: '',
        createdAt: serverTimestamp(),
        location: null,
        answers: {},
        pictureUrl: '',
        beacon: {
          love: [],
          habits: [],
          ambitions: [],
          spirituality: [],
          emotions: []
        }
      });
      console.log("User document created in Firestore");
    }
  };

  // Listen for auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      // Create user document when user signs in
      if (currentUser) {
        await createUserDocument(currentUser);
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        {user ? (
          <Routes>
            <Route path="/" element={<Profile />} />
            <Route path="/questions" element={<Questions />} />
            <Route path="/matches" element={<Matches />} />
            <Route path="/matches/:matchedUserId" element={<MatchDetail />} />
            <Route path="/beacons" element={<Beacons />} />
            <Route path="/admin" element={<AdminQuestions />} />
          </Routes>
        ) : (
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <SignInButton />
          </header>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
